module.exports = __webpack_public_path__ + "img/66.87d856e9.png";